import { InjectionToken } from "@angular/core";

export const TABLE_NESTED_TEMPLATE_CONTEXT = new InjectionToken<{ [key: string]: any }>(
  "Context from table nested template"
);
